module.exports = __webpack_public_path__ + "media/images/frames_arrow-2e20959825be8a2139d02baa79c84853.png";